export class FunctionFactory {
  static create<T>(source: string): T | undefined {
    return source
      ? Function(`return ${source}`)()
      : undefined;
  }
}
